import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { StringKeys } from '../../../resources/strings/StringKeys';
import { Box, Typography, Button } from '@mui/material';
import { Cookie } from '@mui/icons-material';
import COLORS from '../../../resources/style/Themes';
import { useAuth0 } from '@auth0/auth0-react';

const CookieBanner = () => {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const { isAuthenticated } = useAuth0();

  useEffect(() => {
    const cookiesAccepted = localStorage.getItem('cookiesAccepted');
    if (!cookiesAccepted && isAuthenticated) {
      setShow(true);
      setTimeout(() => setIsVisible(true), 4000);
    }
  }, [isAuthenticated]);

  const handleAccept = () => {
    setIsVisible(false);
    setTimeout(() => {
      localStorage.setItem('cookiesAccepted', 'true');
      setShow(false);
    }, 300);
  };

  if (!show) return null;

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: COLORS.WHITE,
        boxShadow: '0 -2px 10px rgba(0,0,0,0.1)',
        zIndex: 9999,
        padding: '16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexDirection: { xs: 'column', sm: 'row' },
        gap: { xs: 2, sm: 0 },
        opacity: isVisible ? 1 : 0,
        transform: isVisible ? 'translateY(0)' : 'translateY(20px)',
        transition: 'opacity 0.3s ease-out, transform 0.3s ease-out',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flex: 1 }}>
        <Cookie sx={{ color: COLORS.SAFEGUARD_BLUE }} />
        <Typography variant="body1">
          {t(StringKeys.WE_USE_NECESSARY_COOKIES_TO_PART_1)}
          <a
            href="https://www.safeguardequipment.com/privacy-policy-apps/"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              textDecoration: 'underline',
              color: COLORS.SAFEGUARD_BLUE,
            }}
          >
            {t(StringKeys.WE_USE_NECESSARY_COOKIES_TO_PART_2)}
          </a>
        </Typography>
      </Box>
      <Button
        variant="contained"
        color="secondary"
        sx={{
          minWidth: '120px',
        }}
        onClick={handleAccept}
      >
        {t(StringKeys.GOT_IT)}
      </Button>
    </Box>
  );
};

export default CookieBanner;
